<nav class="navbar navbar-dark bg-dark">
  <div class="logo ms-3">
    <a style="padding-right: 15px" routerLink="/" class="me-2"
      ><img
        height="60"
        style="margin-top: 10px; margin-bottom: 10px"
        src="{{ logoPath }}"
    /></a>
    <div class="btn-group me-2" *ngIf="canViewMonitor()">
      <button
        type="button"
        class="btn btn-secondary dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <fa-icon [icon]="faTableColumns"></fa-icon> Monitor
      </button>
      <ul class="dropdown-menu">
        <li><a class="dropdown-item" href="/status">Status</a></li>
        <li><hr class="dropdown-divider" /></li>
        <!-- <li>
          <a class="dropdown-item" href="/painel-pendencia-atuacao"
            >Pendências e Atuações</a
          >
        </li>
        <li><hr class="dropdown-divider" /></li> -->
        <li><a class="dropdown-item" href="/todos">Todos</a></li>
        <!-- <li *ngIf="canShow([roles.ViewReceivable])">
          <hr class="dropdown-divider" />
        </li>
        <li *ngIf="canShow([roles.ViewReceivable])">
          <a class="dropdown-item" href="/monitor-recebiveis"
            >Monitor CISA - Ordens</a
          >
        </li>
        <li *ngIf="canShow([roles.ViewReceivable])">
          <hr class="dropdown-divider" />
        </li>
        <li *ngIf="canShow([roles.ViewReceivable])">
          <a class="dropdown-item" href="/monitor-arquivos"
            >Monitor CISA - Arquivos</a
          >
        </li> -->
      </ul>
    </div>
    <div class="btn-group me-2" *ngIf="canCreateAny()">
      <button
        type="button"
        class="btn btn-secondary dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <fa-icon [icon]="faFileInvoice"></fa-icon> Boletas
      </button>
      <ul class="dropdown-menu">
        <li *ngIf="canShow([roles.CreateTicketFundQuota])">
          <a class="dropdown-item" href="/quota">Cota</a>
        </li>

        <li *ngIf="canShow([roles.CreateTicketPrivateFixedIncome])">
          <hr class="dropdown-divider" />
        </li>
        <li *ngIf="canShow([roles.CreateTicketPrivateFixedIncome])">
          <a class="dropdown-item" href="/cetip">RF - Título Privado</a>
        </li>

        <li *ngIf="canShow([roles.CreateTicketPublicFixedIncome])">
          <hr class="dropdown-divider" />
        </li>
        <li *ngIf="canShow([roles.CreateTicketPublicFixedIncome])">
          <a class="dropdown-item" href="/selic">RF - Título Público</a>
        </li>

        <li *ngIf="canShow([roles.CreateTicketFutures])">
          <hr class="dropdown-divider" />
        </li>
        <li *ngIf="canShow([roles.CreateTicketFutures])">
          <a class="dropdown-item" href="/futures">Futuros</a>
        </li>

        <li *ngIf="canShow([roles.CreateTicketMargin])">
          <hr class="dropdown-divider" />
        </li>
        <li *ngIf="canShow([roles.CreateTicketMargin])">
          <a class="dropdown-item" href="/margin">Margem</a>
        </li>

        <li *ngIf="canShow([roles.CreateTicketContracted])">
          <hr class="dropdown-divider" />
        </li>
        <li *ngIf="canShow([roles.CreateTicketContracted])">
          <a class="dropdown-item" href="/contracted"
            >Compromissada <br />de Compra</a
          >
        </li>

        <li *ngIf="canShow([roles.CreateTicketCurrencyTerm])">
          <hr class="dropdown-divider" />
        </li>
        <li *ngIf="canShow([roles.CreateTicketCurrencyTerm])">
          <a class="dropdown-item" href="/currency-term">Termo de Moeda</a>
        </li>

        <li *ngIf="canShow([roles.CreateTicketVariableIncome])">
          <hr class="dropdown-divider" />
        </li>
        <li *ngIf="canShow([roles.CreateTicketVariableIncome])">
          <a class="dropdown-item" href="/uploads/pesc">Renda Variável</a>
        </li>

        <li *ngIf="canShow([roles.CreateTicketSwapCetip])">
          <hr class="dropdown-divider" />
        </li>
        <li *ngIf="canShow([roles.CreateTicketSwapCetip])">
          <a class="dropdown-item" href="/swap-cetip">Swap-CETIP</a>
        </li>

        <li *ngIf="canShow([roles.CreateTicketTransfer])">
          <hr class="dropdown-divider" />
        </li>
        <li *ngIf="canShow([roles.CreateTicketTransfer])">
          <a class="dropdown-item" href="/transfer">Transferência</a>
        </li>

        <li *ngIf="canShow([roles.CreateTicketLoan])">
          <hr class="dropdown-divider" />
        </li>
        <li *ngIf="canShow([roles.CreateTicketLoan])">
          <a class="dropdown-item" href="/loan">Empréstimo</a>
        </li>

        <li *ngIf="canShow([roles.CreateTicketExchange])">
          <hr class="dropdown-divider" />
        </li>
        <li *ngIf="canShow([roles.CreateTicketExchange])">
          <a class="dropdown-item" href="/exchange">Câmbio</a>
        </li>

        <li *ngIf="canShow([roles.CreateExpensesTicket])">
          <hr class="dropdown-divider" />
        </li>
        <li *ngIf="canShow([roles.CreateExpensesTicket])">
          <a class="dropdown-item" href="/expenses">Despesas</a>
        </li>
        <li *ngIf="canShow([roles.CreateLiabilitiesTicket])">
          <hr class="dropdown-divider" />
        </li>
        <!-- <li *ngIf="canShow([roles.CreateLiabilitiesTicket])">
          <a class="dropdown-item" href="/liabilities">Passivo</a>
        </li>

        <li *ngIf="canShow([roles.CreateTicketStructuredOperations])">
          <hr class="dropdown-divider" />
        </li> -->
        <li *ngIf="canShow([roles.CreateTicketStructuredOperations])">
          <a class="dropdown-item" href="/structured">Operações Estruturadas</a>
        </li>
      </ul>
    </div>
    <div class="btn-group me-2" *ngIf="canShow([roles.GestorCreateTicket])">
      <button
        type="button"
        class="btn btn-secondary dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <fa-icon [icon]="faFileImport"></fa-icon> Upload Boletas
      </button>
      <ul class="dropdown-menu">
        <li *ngIf="canShow([roles.CreateTicketVariableIncome])">
          <a class="dropdown-item" href="/uploads/pesc">Upload PESC</a>
        </li>
        <li *ngIf="canShow([roles.GestorCreateTicket])">
          <hr class="dropdown-divider" />
        </li>
        <li *ngIf="canShow([roles.GestorCreateTicket])">
          <a class="dropdown-item" href="/uploads/ticket">Upload de Boletas</a>
        </li>
      </ul>
    </div>

    <div class="btn-group me-2">
      <button
        type="button"
        class="btn btn-secondary dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <fa-icon [icon]="faNewspaper"></fa-icon> Relatórios
      </button>
      <ul class="dropdown-menu">
        <li>
          <a class="dropdown-item" href="/wallet">Downloads</a>
        </li>
        <hr class="dropdown-divider" />
        <li>
          <a class="dropdown-item" href="/relatorio-upload">Uploads</a>
        </li>
      </ul>
    </div>

    <div class="btn-group me-2" *ngIf="canShow([roles.AdminCreateLoad])">
      <button
        type="button"
        class="btn btn-secondary dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <fa-icon [icon]="faCloudArrowDown"></fa-icon> Cargas
      </button>
      <ul class="dropdown-menu">
        <li>
          <a class="dropdown-item" href="/uploads/carga">Upload de Carga</a>
        </li>
        <li><hr class="dropdown-divider" /></li>
        <li><a class="dropdown-item" href="/obter-cargas">Obter Cargas</a></li>
      </ul>
    </div>
    <div class="btn-group me-2" *ngIf="canShowSecurity()">
      <button
        type="button"
        class="btn btn-secondary dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <fa-icon [icon]="faShield"></fa-icon> Segurança
      </button>
      <ul class="dropdown-menu">
        <li
          *ngIf="canShow([roles.CreateMasterUser, roles.CreateSubordinateUser])"
        >
          <a class="dropdown-item" href="/usuarios">Usuários</a>
        </li>

        <li *ngIf="canShow([roles.ViewCountarpart])">
          <hr class="dropdown-divider" />
        </li>
        <li *ngIf="canShow([roles.ViewCountarpart])">
          <a class="dropdown-item" href="/counterpart">Contrapartes</a>
        </li>

        <li *ngIf="canShow([roles.CreateMasterUser])">
          <hr class="dropdown-divider" />
        </li>
        <li *ngIf="canShow([roles.CreateMasterUser])">
          <a class="dropdown-item" href="/grupos">Grupos</a>
        </li>

        <li *ngIf="canChangeCutoff()"><hr class="dropdown-divider" /></li>
        <li *ngIf="canChangeCutoff()">
          <a class="dropdown-item" href="/cutoff">Cutoff</a>
        </li>

        <li *ngIf="canShow([roles.AdminCreateLoad])">
          <hr class="dropdown-divider" />
        </li>
        <li *ngIf="canShow([roles.AdminCreateLoad])">
          <a class="dropdown-item" href="/calendario">Calendário</a>
        </li>
      </ul>
    </div>
    <div class="btn-group me-2" *ngIf="canShowUtility()">
      <button
        type="button"
        class="btn btn-secondary dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <fa-icon [icon]="faGears"></fa-icon> Utilidades
      </button>
      <ul class="dropdown-menu">
        <li>
          <a class="dropdown-item" href="/batch-email">Email em Lote</a>
        </li>
        <li>
          <hr class="dropdown-divider" />
        </li>
        <li>
          <a class="dropdown-item" href="/bank-list">Cadastrar Banco</a>
        </li>
      </ul>
    </div>
    <div class="btn-group me-2">
      <button
        type="button"
        class="btn btn-secondary dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <fa-icon [icon]="faNewspaper"></fa-icon> Releases
      </button>
      <ul class="dropdown-menu">
        <li><a class="dropdown-item" href="/releases">Releases</a></li>
      </ul>
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="isNotProduction">
      <h6 class="mb-0">
        ATENÇÃO: ESTE É UM AMBIENTE DE TESTE. NÃO EXECUTE OPERAÇÕES REAIS.
      </h6>
    </div>
  </div>
  <div class="me-3">
    <div class="dropdown">
      <button
        class="btn btn-secondary dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <fa-icon [icon]="faUser"></fa-icon> {{ auth.name }}
      </button>
      <div class="dropdown-menu dropdown-menu-right">
        <button class="dropdown-item" (click)="changePassword()">
          Trocar Senha
        </button>
        <div class="dropdown-divider"></div>
        <button class="dropdown-item" (click)="signout()">Sair</button>
      </div>
    </div>
  </div>
</nav>
<div class="collapse" id="navbarToggleExternalContent">
  <app-nav-menu></app-nav-menu>
</div>
